export default "__VITE_ASSET__CO5l84Hp__"